import React from "react";

import {
  StyledVideoPresenter,
  StyledVideo,
  StyledVideoTime,
  StyledVideoPresenterProps,
} from "./styled";
import { formatTime } from "utils/common";

type VideoPresenterProps = {
  src?: string;
  controls?: boolean;
} & StyledVideoPresenterProps;

export const VideoPresenter: React.FC<VideoPresenterProps> = ({
  src,
  controls,
  ...styles
}) => {
  const [aspectRatio, setAspectRatio] = React.useState<string>();
  const [videoDuration, setVideoDuration] = React.useState<number | null>();
  const videoRef = React.useRef<HTMLVideoElement>(null);

  const onLoaded = () => {
    if (!videoRef.current) return;
    setVideoDuration(videoRef.current.duration);
    setAspectRatio(
      `${videoRef.current.videoWidth}/${videoRef.current.videoHeight}`
    );

    //描画外の動画が印刷時黒くなってしまう問題の対応
    videoRef.current.currentTime = 0;
  };

  return (
    <StyledVideoPresenter {...styles} aspectRatio={aspectRatio}>
      <StyledVideo
        src={src}
        controls={controls}
        ref={videoRef}
        onLoadedData={onLoaded}
      />
      {!controls && videoDuration ? (
        <StyledVideoTime>{formatTime(videoDuration)}</StyledVideoTime>
      ) : (
        <></>
      )}
    </StyledVideoPresenter>
  );
};
